/**
 * GeoLatte Polygon(LinearRing) 요구: 첫 점과 마지막 점이 같아야 함.
 * API shapeCoordinates 전송 전에 링을 닫는다.
 */
export function closeRingCoordinates(ring) {
  if (!ring?.length) {
    return [];
  }
  if (ring.length < 3) {
    return ring.map(c => [...c]);
  }
  const closed = ring.map(c => [...c]);
  const first = closed[0];
  const last = closed[closed.length - 1];
  if (first[0] !== last[0] || first[1] !== last[1]) {
    closed.push([first[0], first[1]]);
  }
  return closed;
}
